"use client";

import React from "react";
import { logout } from "lib/api";

type Props = {
  title: string;
};
export const SignOutButton = ({ title }: Props): JSX.Element => {
  const onClick = async () => {
    await logout();
    window.location.reload();
  };
  return (
    <button type="button" onClick={onClick}>
      {title}
    </button>
  );
};
